const authHighlights = [
  { icon: '/assets/auth/icons/inform-decision-making.svg', label: 'Inform decision making' },
  { icon: '/assets/auth/icons/customer-analysis.svg', label: 'Customer analysis' },
  { icon: '/assets/auth/icons/staff-self-management.svg', label: 'Staff self management' },
  { icon: '/assets/auth/icons/attract-and-retain-talent.svg', label: 'Attract and retain talent' },
  { icon: '/assets/auth/icons/maximise-profits.svg', label: 'Maximise profits' },
  { icon: '/assets/auth/icons/optimise-resources.svg', label: 'Optimise resources' },
]

type AuthHighlightsProps = {
  compact?: boolean
}

export default function AuthHighlights({ compact }: AuthHighlightsProps) {
  return (
    <div className={compact ? 'mt-[2rem] space-y-[1rem]' : 'mt-10 space-y-5'}>
      {authHighlights.map((item) => (
        <div key={item.label} className="flex items-center gap-3 text-gray-800">
          <img src={item.icon} alt="" className={compact ? 'h-[1.5rem] w-[1.5rem] shrink-0' : 'h-7 w-7 shrink-0'} />
          <span className={compact ? 'text-[1rem] leading-[1.15]' : 'text-[27px] leading-none'}>{item.label}</span>
        </div>
      ))}
    </div>
  )
}
